import React, { ReactElement } from 'react'
import { InfoBlock, TooltipDiv, InfoTextDiv, ArrowDown } from './styles'

interface TooltipProps {
    text: string | ReactElement
    color?: string
    className?: string
    height?:number
    width?:number
    maxWidth?:string
    // only for storybook testing:
    visibility?: 'visible' | 'hidden'
}
const Tooltip = ({ text, color = '#000', width, height, maxWidth, className, visibility }: TooltipProps): ReactElement => {
    return (
        <TooltipDiv className={className} visibility={visibility}>
            <InfoBlock className="info-block" color={color} height={height} width={width} maxWidth={maxWidth}>
                {<InfoTextDiv>{text}</InfoTextDiv>}
            </InfoBlock>
            <ArrowDown color={color} />
        </TooltipDiv>
    )
}

export default Tooltip
